export function getClassName(obj: unknown): string | undefined {
  return obj?.constructor?.name;
}
